import { getReq, putReq, postReq, deleteReq } from '../api/restHelper'

function getProject(dispatch, getState){
    const state = getState()
    getReq('project?page=1&per_page=-1&workspace=' + state.app.work_space.id,(response)=>{
        dispatch({type: "FETCH_DATA_SUCCESS", payload: response})
    });
}

export function fetchProjectList(response) {
    return (dispatch, getState)=> {
        getProject(dispatch, getState)
    }
}

export function changeColorPickerStatus() {
    return {
        type: "CHANGE_COLOR_PICKER_STATUS"
    }
}

export function closeColorPicker() {
    return {
        type: "CLOSE_COLOR_PICKER"
    }
}

export function updateData(data, closeModal=()=>{}){
    return (dispatch, getState)=>{
        let obj = {
            'color': parseInt(data.color.slice(1),16),
            'name': data.name,
            'users': []
        };
        const appData = JSON.parse(localStorage.getItem('appData'));
        const ownerPhone = appData.user['phone_number'];
        data.users.map((user)=>{
            if(user.selected && user.phone_number !== ownerPhone){
                obj.users.push(user.phone_number)
            }
            return true;
        })

        if( data.id ){
            putReq(obj, 'project/'+ data.id, (response)=>{
                getProject(dispatch, getState)
                closeModal();
            })
        }else{
            obj.workspace = data.workspace;
            postReq(obj,'project',(response)=>{
                getProject(dispatch, getState)
                closeModal();
            })
        }
    }
}

// this function is a short copy of fetchMainDataFunction in actions/app.js
function setWorkspaceFunction (dispatch) {
    if(!localStorage.work_space){
        getReq('workspace?page=1&per_page=-1',(res)=>{
            dispatch({ type:'SET_WORKSPACE', payload:res.data.list[0] })
            localStorage.work_space = res.data.list[0].id;
        }, ()=>{},false,false );
    }
    else{
        let storageData = localStorage.work_space;
        getReq( 'workspace/' + storageData , (res)=>{
            dispatch({ type:'SET_WORKSPACE', payload:res.data})
            localStorage.work_space = res.data.id;
        }, ()=>{ localStorage.removeItem("work_space"); setWorkspaceFunction(); },false,false );
    }
}

//adding callback to this function
export function changeActivationStatus(id, status){
    return (dispatch)=>{
        if(status){
            postReq({},'project/'+id+'/deactive', (response)=>{
                dispatch({type: "CHANGE_ACTIVATION", payload: response})
                setWorkspaceFunction(dispatch);
            })
        }else{ 
            postReq({},'project/'+id+'/active', (response)=>{
                dispatch({type: "CHANGE_ACTIVATION", payload: response})
                setWorkspaceFunction(dispatch);
            })
        }
    }
}

export function deleteProject(id){
    return (dispatch, getState) => {
        deleteReq('project/' + id, (response)=>{
            getProject(dispatch, getState)
        })
    }
}